/** @global oyc */
oyc.NotePad = {
  dependencies: ['FormFilter'],
  selectors: {
    container: '.jobs-list-container, .sharing-bar',
    filterForm: '.jobs-filter-form',
    vacancyList: '.jobs-list',
    toggleButton: '.notepad-toggle',
    clickItem: '.notepad-item',
    listItem: '.list-item',
    dataFieldPattern: 'tx_oycimport_list[|]',
  },

  storageKey: 'vacancyNotepad',

  container: null,
  vacancyList: null,
  filterContainer: null,
  clickItems: null,

  eventsAdded: false,

  ids: [],
  notepadList: null,
  notepadListItems: null,
  itemRequest: null,
  ajaxQueryString: 'type=1201&tx_oycimport_vacancy[controller]=Vacancy&tx_oycimport_vacancy[action]=',
  searchList: null,

  itemTemplate: null,

  init: function () {
    this.container = document.querySelector(this.selectors.container);
    if (this.container) {
      // buttons to add/remove from notepad
      this.clickItems = this.container.querySelectorAll(this.selectors.clickItem);
      if (0 < this.clickItems.length) {
        // template to generate
        this.itemTemplate = document.getElementById('notePadItem');
      }
      // list with job-items
      this.vacancyList = this.container.querySelector(this.selectors.vacancyList);
      this.filterContainer = this.container.querySelector(this.selectors.filterForm);
      // button to show the notepad
      this.toggleButton = this.container.querySelector(this.selectors.toggleButton);
      this.addEvents();
      this.loadStorage();
      if (this.toggleButton) {
        if (0 < this.ids.length) {
          this.initNotepadList();
        } else {
          this.deactivateToggle();
        }
      } else {
        this.activateStoredItems();
      }
    }
  },
  initNotepadList: function () {
    this.notepadList = document.createElement('ul');
    this.notepadList.id = 'notepad-list';
    this.requestFavoriteList(this.ids);
    this.activateStoredItems();
  },
  addEvents: function () {
    if (!this.eventsAdded) {
      this.toggleButton && this.toggleButton.addEventListener('click', this.clickToggle.bind(this));
      this.container.addEventListener('click', (ev) => {
        if (!ev.target.closest(this.selectors.clickItem) || (this.toggleButton && (ev.target.matches(this.selectors.toggleButton) || ev.target.closest(this.selectors.toggleButton)))) {
          return;
        }
        if (!ev.target.classList.contains(this.selectors.clickItem)) {
          const clickedItem = ev.target.closest(this.selectors.clickItem) || ev.target.closest(this.selectors.listItem).querySelector(this.selectors.clickItem);
          if (clickedItem) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            const myEv = new Event('click', {bubbles: false, cancelable: true});
            this.clickItem(Object.defineProperty(myEv, 'currentTarget', {writable: false, value: clickedItem}));
          }
        } else {
          this.clickItem(ev);
        }
      });
      this.container.addEventListener('oyc-pager-append-items', this.activateStoredItems.bind(this));
      this.eventsAdded = true;
    }
  },

  clickItem: function (ev) {
    const el = ev.currentTarget, id = el.dataset.id;
    if (el.classList.contains('active')) {
      // deactivate/remove an item
      this.ids.splice(this.ids.indexOf(id), 1);
      this.removeFromList(ev.currentTarget)
      this.deactivateClickItem(ev.currentTarget);
    } else {
      this.ids.push(id);
      this.activateClickItem(ev.currentTarget);
    }
    if (0 === this.ids.length) {
      this.deactivateToggle();
    } else if (0 < this.ids.length) {
      this.activateToggle();
    }
    this.updateStorage();
  },

  /**
   * callback to show entries from notepad
   * list is loaded during initialization
   * @param ev
   */
  clickToggle: function (ev) {
    if (this.toggleButton.classList.contains('disabled')) {
      console.log('note pad view is disabled - empty list');
      return;
    }
    if (this.toggleButton.classList.contains('active')) {
      this.toggleButton.classList.remove('active');
      this.vacancyList.innerHTML = this.searchList;
    } else {
      this.searchList = this.vacancyList.innerHTML;
      this.vacancyList.innerHTML = this.notepadList.innerHTML;
      this.toggleButton.classList.add('active');
    }
  },
  /**
   * retrieve stored ids an listItems from localStorage
   */
  loadStorage: function () {
    if (localStorage.getItem(this.storageKey) === null) {
      localStorage.setItem(this.storageKey, '');
    }
    let storage = localStorage.getItem(this.storageKey) || '';
    if (storage === '') {
      this.deactivateToggle();
    } else {
      storage = JSON.parse(storage);
      this.ids = storage.ids;
      this.notepadListItems = storage.listItems;
      console.log('NotePad.loadStorage', storage, this.ids, this.notepadListItems, (Date.now() / 1000) - storage.tStamp || 0);
    }
  },
  /**
   * update the value inside localStorage
   */
  updateStorage: function () {
    const listItemMarkup = {};
    if (this.toggleButton) {
      this.notepadListItems.forEach(item => listItemMarkup[item.dataset.id] = item.outerHTML)
    }
    let storage = {
      ids: this.ids,
      listItems: this.notepadListItems,
      tStamp: Math.round((Date.now() / 1000) / (30 * 60)) * (30 * 60)
    }
    console.log('Notepad.updateStorage', storage);
    localStorage.setItem(this.storageKey, JSON.stringify(storage));
  },
  /**
   * ensure the items in notepadList are active
   */
  activateStoredItems: function () {
    for (let i = 0; i < this.ids.length; i++) {
      let button = this.container.querySelector('[data-id="' + this.ids[i] + '"]');
      if (button) {
        this.activateClickItem(button);
      }
    }
  },
  /**
   * @param {HTMLButtonElement} button
   */
  removeFromList: function (button) {
    delete (this.notepadListItems[button.dataset.id]);
    this.ids.splice(this.ids.indexOf(button.dataset.id), 1);
    this.updateStorage();
    // we are on the list page so update the list itself
    if (this.toggleButton && this.length === 0) {
      button.closest(this.selectors.listItem).remove();
      this.deactivateToggle();
    }
  },
  /**
   *
   * @param {array<int>} ids
   */
  requestFavoriteList: function (ids) {
    let formData = new FormData();
    formData.set(this.selectors.dataFieldPattern.replace('|', 'notepad'), ids.join(','));
    this.itemRequest = oyc.FormFilter.invokeAjax(formData, '1201').then(this.fetchFavoriteList.bind(this))
  },
  /**
   * @param {string} data
   */
  fetchFavoriteList: function (data) {
    this.notepadListItems = document.createRange().createContextualFragment(data).querySelectorAll(this.selectors.listItem);
    this.ids = [];
    if (0 < this.notepadListItems.length) {
      this.notepadListItems = Array.from(this.notepadListItems);
      this.notepadList.innerHTML = '';
      this.notepadListItems.forEach((notepadItem) => {
        this.notepadList.appendChild(notepadItem);
        this.ids.push(notepadItem.dataset.id);
      });
    } else {
      this.deactivateToggle();
      this.notepadListItems = [];
    }
    this.updateStorage();
  },
  /**
   * change button state to "not in list"
   * @param {HTMLButtonElement} button
   */
  deactivateClickItem: function (button) {
    button.classList.remove('active');
    button.querySelector('span').innerHTML = 'Job merken';
  },
  activateClickItem: function (button) {
    button = button || this.toggleButton;
    button.classList.add('active');
    button.querySelector('span').innerHTML = 'Job entfernen';
  },

  deactivateToggle: function () {
    if (!this.toggleButton) {
      return;
    }
    if (this.toggleButton.classList.contains('active')) {
      this.toggleButton.click();
    }
    this.toggleButton.classList.add('disabled')
    this.toggleButton.disabled = 'disabled';
    this.toggleButton.title = 'Es sind keine Stellen im Merkzettel vorhanden.';

  },
  activateToggle: function () {
    if (!this.toggleButton) {
      return;
    }
    this.toggleButton.classList.remove('disabled');
  }

}
